import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
        <li><Link to="/" className="hover:text-primary transition-colors">Home</Link></li>
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight className="h-3 w-3 opacity-50" />
            {it.to ? (
              <Link to={it.to} className="hover:text-primary transition-colors">{it.label}</Link>
            ) : (
              <span className="text-foreground font-semibold">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
